import React from 'react'
import Header from "../../components/Header/Header"
import Footer from "../../components/Footer/Footer"
import Images from "../../components/Images/Images"

export default function Gallery() {

    return (
        <>
            <Header />
            <section>
                <Images />
            </section >
            <Footer />
        </>
    )
}
